if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      }
      this.position = {
        x: 0,
        left: 0,
        slider: this.querySelector('[id^="GalleryViewer"]').querySelector("ul"),
        enabled: (! ('ontouchstart' in window)),
        moveEvent: this.onDrag.bind(this),
        upEvent: this.onDragStop.bind(this),
        cardWidth: 0
      }

      this.mql = window.matchMedia('(min-width: 750px)');
      if (!this.elements.thumbnails) return;

      // this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));


      if (this.position.enabled) {
        const cloneFirst = this.position.slider.firstChild.cloneNode(true);
        const cloneSecond = this.position.slider.children[1].cloneNode(true);
        const cloneLast = this.position.slider.lastChild.cloneNode(true);
        const cloneSecondLast = this.position.slider.children[this.position.slider.children.length - 2].cloneNode(true);
  
        this.position.slider.appendChild(cloneFirst);
        this.position.slider.appendChild(cloneSecond);
        this.position.slider.insertBefore(cloneLast, this.position.slider.firstChild);
        this.position.slider.insertBefore(cloneSecondLast, cloneLast);

        this.position.cardWidth = cloneFirst.offsetWidth;

        this.position.slider.scrollLeft = this.position.cardWidth * 2;
  
        this.position.slider.classList.add('drag-scroll--enabled');
        this.position.slider.addEventListener('mousedown', this.onDragStart.bind(this));

      }
      this.position.slider.addEventListener("wheel", this.onScroll.bind(this));

      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
      });
      if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
    }

    onScroll(event) {
      window.scrollTo(window.scrollX, window.scrollY + event.deltaY);
    }

    onDragStart(event) {
      if (this.position.enabled) {
        this.position.x = event.clientX;
        this.position.left = this.position.slider.scrollLeft;
        this.position.slider.addEventListener('mousemove', this.position.moveEvent);
        this.position.slider.addEventListener('mouseup', this.position.upEvent);
        document.querySelector(".product__info-wrapper").addEventListener('mouseup',this.position.upEvent);
        this.position.slider.classList.add('drag-scroll--scrolling');
      }
    }

    onDrag(event) {
      this.infiniteScroll(event.clientX);
    }


    onDragStop(event) {
      if (this.position.enabled) {
        this.infiniteScroll(event.clientX);
        this.position.x = undefined;
        this.position.slider.removeEventListener('mousemove', this.position.moveEvent);
        this.position.slider.removeEventListener('mouseup', this.position.upEvent);
        document.querySelector(".product__info-wrapper").removeEventListener('mouseup',this.position.upEvent);
        this.position.slider.classList.remove('drag-scroll--scrolling');
      }
    }

    infiniteScroll(amount) {
      const sliderW = this.position.slider.scrollWidth - this.position.slider.offsetWidth;
      if (this.position.slider.scrollLeft === sliderW) {
        // At the end, move to start
        this.position.slider.scrollLeft = (this.position.cardWidth * 1.5) - sliderW;
        this.position.left = this.position.cardWidth * 1.5;
      } else if (this.position.slider.scrollLeft === 0) {
        // At the start, move to the end
        this.position.left = sliderW - (this.position.cardWidth * 1.5);
        this.position.slider.scrollLeft = sliderW - (this.position.cardWidth * 1.5);
      }
      if (this.position.x) {
        // move
        const dragX = amount - this.position.x;
        this.position.slider.scrollLeft = this.position.left - dragX;
      }
    }

    onSlideChanged(event) {
      const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ event.detail.currentElement.dataset.mediaId }"]`);
      this.setActiveThumbnail(thumbnail);
    }

    setActiveMedia(mediaId, prepend) {
      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      activeMedia.classList.add('is-active');

      if (prepend) {
        activeMedia.parentElement.prepend(activeMedia);
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
          activeThumbnail.parentElement.prepend(activeThumbnail);
        }
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }

      this.preventStickyHeader();
      window.setTimeout(() => {
        if (this.elements.thumbnails) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        }
        if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
          activeMedia.scrollIntoView({behavior: 'smooth'});
        }
      });
      this.playActiveMedia(activeMedia);

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
      this.setActiveThumbnail(activeThumbnail);
      this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
      thumbnail.querySelector('button').setAttribute('aria-current', true);
      if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

      this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
  });
}



